module.exports = __webpack_public_path__ + "static/media/Angle-right.d11151a0.svg";